import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import LockOutlined from "@material-ui/icons/LockOutlined";
import Email from "@material-ui/icons/Email";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import CalendarTodayOutlined from "@material-ui/icons/CalendarTodayOutlined";
import LocationOnOutlined from "@material-ui/icons/LocationOnOutlined";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import grey from "@material-ui/core/colors/grey";
import { reduxForm, Field, change, untouch, submit } from "redux-form";
import {
  geo_fetchRegions,
  geo_fetchCities
} from "../../../redux/actions/geoActions";
import { common_alertOpen } from "../../../redux/actions/commonActions";
import "react-datepicker/dist/react-datepicker.css";
import PrivacyPolicyLink from "../../shared/components/PrivacyPolicyLink";
import {
  renderTextField,
  renderRadioGroup,
  CheckboxGroup
} from "../../../helpers/form/renders";
import {
  renderHeightField,
  renderWeightField
} from "../../../helpers/form/fields";
import {
  renderEmailField,
  renderPasswordField,
  renderLastNameField,
  renderFirstNameField,
  renderGenericTextField,
  renderSecondLastNameField,
  renderDateOfBirthField,
  renderRegionsField,
  renderCountriesField,
  renderCitiesField,
  renderNationalitiesField,
  renderDniField,
  renderAddressField,
  renderCityField,
  renderPostalCodeField,
  renderMobilePhoneField,
  renderAlternativePhoneNumberField,
  renderTestTypeField,
  renderTestApplicationZone,
  renderContactMethodsField,
  renderContactTimeFiled,
  renderGenericHiddenField
} from "../../../helpers/form/fields";

import {
  v_required,
  v_email,
  v_arrayMinLength,
  v_number,
  v_nifNie,
  v_height,
  v_policy
} from "../../../helpers/form/validators";
import * as API from "../../../api";
import { connect } from "react-redux";
import MobileStepper from "@material-ui/core/MobileStepper";

const primaryGrey = grey[600]; // #F44336

const validate = values => {
  console.log("validate values", values);

  const errors = {
    profile: {}
  };

  // Step 0
  errors.email = v_email(values.email);
  errors.password = v_required(values.password);
  errors.first_name = v_required(values.first_name);
  errors.last_name = v_required(values.last_name);

  // Step 1
  errors.dni = v_nifNie(values.dni);
  errors.nationality = v_required(values.nationality);
  errors.country_of_birth = v_required(values.country_of_birth);
  errors.birthday = v_required(values.birthday);

  // Step 2
  errors.address = v_required(values.address);
  errors.city = v_required(values.city);
  errors.postal_code = v_number(values.postal_code);
  errors.mobile_phone_number = v_number(values.mobile_phone_number);

  // Step 3
  errors.test_type = v_required(values.test_type);
  if (
    !Array.isArray(values.test_type) ||
    (Array.isArray(values.test_type) && values.test_type.length === 0)
  ) {
    errors.test_type = "Campo obligatorio";
  }
  errors.test_application_zone = v_required(values.test_application_zone);
  // errors.test_type = v_required(values.test_type);
  if (
    !Array.isArray(values.test_application_zone) ||
    (Array.isArray(values.test_application_zone) &&
      values.test_application_zone.length === 0)
  ) {
    errors.test_application_zone = "Campo obligatorio";
  }
  errors.contact_method = v_arrayMinLength(1, values.contact_method);
  errors.contact_time = v_arrayMinLength(1, values.contact_time);

  // Step 4
  errors.immunosuppressive_treatment = v_required(
    values.immunosuppressive_treatment
  );
  errors.other_treatment = v_required(values.other_treatment);
  if (values.other_treatment === "Sí") {
    errors.other_treatment_description = v_required(
      values.other_treatment_description
    );
  }
  //errors.legal_drug = v_required(values.legal_drug);
  errors.organ_transplant = v_required(values.organ_transplant);
  errors.had_surgery = v_required(values.had_surgery);
  if (values.had_surgery === "Sí") {
    errors.had_surgery_description = v_required(values.had_surgery_description);
  }
  errors.cranial_trauma = v_required(values.cranial_trauma);
  errors.skin_affection_answer = {};
  if (values.skin_affection && values.skin_affection.length > 0) {
    values.skin_affection.forEach((member, memberIndex) => {
      if (
        !values.skin_affection_answer ||
        !values.skin_affection_answer[member] ||
        values.skin_affection_answer[member].length < 1
      ) {
        errors.skin_affection_answer[member] = "Campo obligatorio";
      }
    });
  }

  // Step 5
  errors.has_allergies = v_required(values.has_allergies);
  if (values.has_allergies === "Sí") {
    errors.has_allergies_user_input = v_required(
      values.has_allergies_user_input
    );
  }
  errors.family_has_allergies = v_required(values.family_has_allergies);
  if (values.family_has_allergies === "Sí") {
    errors.family_has_allergies_user_input = v_required(
      values.family_has_allergies_user_input
    );
  }
  errors.reactions_to_insect_bites = v_required(
    values.reactions_to_insect_bites
  );
  errors.reactions_to_sun = v_required(values.reactions_to_sun);
  errors.food_allergies = v_required(values.food_allergies);
  if (values.food_allergies === "Sí") {
    errors.food_allergies_user_input = v_required(
      values.food_allergies_user_input
    );
  }
  errors.drug_allergies = v_required(values.drug_allergies);
  if (values.drug_allergies === "Sí") {
    errors.drug_allergies_user_input = v_required(
      values.drug_allergies_user_input
    );
  }
  errors.cosmetic_product_allergies = v_required(
    values.cosmetic_product_allergies
  );
  if (values.cosmetic_product_allergies === "Sí") {
    errors.cosmetic_product_allergies_description_product = v_required(
      values.cosmetic_product_allergies_description_product
    );
    errors.cosmetic_product_allergies_description_body_zone = v_required(
      values.cosmetic_product_allergies_description_body_zone
    );
  }
  errors.possible_affections_answer = {};
  console.log("values.possible_affections", values.possible_affections);
  // if (values.possible_affections && values.possible_affections.length > 0) {
  //   values.possible_affections.forEach((member, memberIndex) => {
  //     if (
  //       member > 3 &&
  //       values.possible_affections[member] &&
  //       (!values.possible_affections_answer ||
  //         !values.possible_affections_answer[member])
  //     ) {
  //       errors.possible_affections_answer[member] = "Campo obligatorio";
  //     }
  //   });
  // }
  if (
    values.possible_affections &&
    values.possible_affections.find(a => a === 4) > -1 &&
    (!values.possible_affections_answer ||
      !values.possible_affections_answer[4] ||
      values.possible_affections_answer[4].length === 0)
  ) {
    errors.possible_affections_answer[4] = "Campo obligatorio";
  }
  if (
    values.possible_affections &&
    values.possible_affections.find(a => a === 5) > -1 &&
    (!values.possible_affections_answer ||
      !values.possible_affections_answer[5] ||
      values.possible_affections_answer[5].length === 0)
  ) {
    errors.possible_affections_answer[5] = "Campo obligatorio";
  }

  // Step 6
  errors.gender = v_required(values.gender);
  errors.weight = v_number(values.weight);
  errors.height = v_height(values.height);
  errors.is_smoking = v_required(values.is_smoking);
  if (!values.is_smoking) {
    errors.is_smoking = "Campo obligatorio";
  }
  if (values.is_smoking === "Sí") {
    errors.smoking_user_input = v_required(values.smoking_user_input);
  }
  errors.has_tattoos = v_required(values.has_tattoos);
  console.log(values.has_tattoos);
  if (values.has_tattoos === "Sí") {
    errors.has_tattoos_value = v_required(values.has_tattoos_value);
  }
  errors.enrolled_in_other_center = v_required(values.enrolled_in_other_center);
  errors.social_security_affiliation = v_required(
    values.social_security_affiliation
  );

  // Step 7

  errors.health_and_care_products = v_required(values.health_and_care_products);
  if (values.health_and_care_products === "Sí") {
    errors.health_and_care_products_answer = v_required(
      values.health_and_care_products_answer
    );
  }
  errors.health_and_care_products_answer = {};
  if (
    values.health_and_care_products &&
    values.health_and_care_products.findIndex(p => p === 4) > -1 &&
    (!values.health_and_care_products_answer ||
      !values.health_and_care_products_answer[4])
  ) {
    errors.health_and_care_products_answer[4] = "Campo obligatorio";
  }
  if (
    values.health_and_care_products &&
    values.health_and_care_products.length > 0
  ) {
    values.health_and_care_products.forEach((product, index) => {
      if (
        !values.health_and_care_products_answer ||
        !values.health_and_care_products_answer[product]
      ) {
        errors.health_and_care_products_answer[product] = "Campo obligatorio";
      }
    });
  }
  errors.use_hair_removal_products = v_required(
    values.use_hair_removal_products
  );
  if (values.use_hair_removal_products === "Sí") {
    errors.hair_removal_zones = v_required(values.hair_removal_zones);
    if (!values.hair_removal_zones || values.hair_removal_zones.length < 1) {
      errors.hair_removal_zones = "Campo obligatorio";
    }
    if (
      !values.hair_removal_products_list ||
      values.hair_removal_products_list.length < 1
    ) {
      errors.hair_removal_products_list = "Campo obligatorio";
    }
    // errors.hair_removal_products_list = v_required(values.hair_removal_products_list);
  }
  errors.had_laser_hair_removal = v_required(values.had_laser_hair_removal);
  if (
    values.had_laser_hair_removal === "Sí" &&
    (!values.hair_removal_zones_laser ||
      values.hair_removal_zones_laser.length < 1)
  ) {
    errors.hair_removal_zones_laser = "Campo obligatorio";
  }
  errors.policies = v_policy(3, values.policies);

  return errors;
};

const styles = theme => ({
  root: {
    maxWidth: 400,
    flexGrow: 1
  },
  mobileStepper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%"
  },
  logIn: {
    textTransform: "initial",
    padding: 0,
    fontWeight: 300,
    lineHeight: "2.4em",
    fontSize: "0.69rem",
    color: "rgba(142, 101, 252, 1)"
  },
  buttonIndigo: theme.custom.button.indigo,
  buttonIndigoLight: {
    backgroundColor: "rgba(0,0,255,0.3)",
    color: "#fff"
  }
});

class RegisterAccountForm extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      activeStep: 0,
      has_children: false,
      accept_children_to_test: false,
      allowNextStep: false
    };

    this.passwordInput = React.createRef();
    this.emailInput = React.createRef();
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  componentDidMount() {
    this.props.change("account_type", "1");
    this.props.changeLayout(this.state.activeStep);
  }
  checkEmailandNext = () => {
    if (
      this.textInput.value == undefined ||
      this.textPassword.value == undefined ||
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.textInput.value)
    ) {
      this.props.dispatch(
        common_alertOpen("Please fill in the email and password fields")
      );
    } else {
      API.checkEmail(this.textInput.value)
        .then(status => {
          status.status === 409
            ? this.props.dispatch(
                common_alertOpen("Ya existe un usuario con este email")
              )
            : this.setState(state => ({
                activeStep: state.activeStep + 1
              }));
        })
        .catch(err => console.log(err));
    }
  };

  handleNext = () => {
    if (this.props.valid && this.state.activeStep < 7) {
      this.setState(state => ({
        activeStep: state.activeStep + 1
      }));
    } else if (!this.props.valid) {
      if (this.state.activeStep == 0) {
        this.props.touch("email");
        this.props.touch("password");
        // this.touchFieldsByStep(0);
      }
      if (this.state.activeStep == 1) {
        this.props.touch("first_name");
        this.props.touch("last_name");
        this.props.touch("dni");
        this.props.touch("birthday");
        this.props.touch("nationality");
        this.props.touch("country_of_birth");
      }
      if (this.state.activeStep == 2) {
        this.props.touch("address");
        this.props.touch("city");
        this.props.touch("postal_code");
        this.props.touch("mobile_phone_number");
      }
      if (this.state.activeStep == 3) {
        this.props.touch("test_type");
        this.props.touch("test_application_zone");
        this.props.touch("contact_method");
        this.props.touch("contact_time");
      }
      if (this.state.activeStep == 4) {
        this.props.touch("disease_type");
        this.props.touch("disease_type_other");
        this.props.touch("immunosuppressive_treatment");
        this.props.touch("other_treatment");
        this.props.touch("other_treatment_description");
        //this.props.touch('legal_drug');
        this.props.touch("organ_transplant");
        this.props.touch("had_surgery");
        this.props.touch("had_surgery_description");
        this.props.touch("cranial_trauma");
        this.props.touch("contraception");
        this.props.touch("skin_affection");
        // this.props.touch('skin_affection_answer[1]');
        for (let i = 1; i <= 7; i++) {
          this.props.touch(`skin_affection_answer[${i}]`);
        }
      }
      if (this.state.activeStep == 5) {
        this.props.touch("has_allergies");
        this.props.touch("has_allergies_user_input");
        this.props.touch("family_has_allergies");
        this.props.touch("family_has_allergies_user_input");
        this.props.touch("reactions_to_insect_bites");
        this.props.touch("reactions_to_sun");
        this.props.touch("food_allergies");
        this.props.touch("food_allergies_user_input");
        this.props.touch("drug_allergies");
        this.props.touch("drug_allergies_user_input");
        this.props.touch("cosmetic_product_allergies");
        this.props.touch("cosmetic_product_allergies_description_product");
        this.props.touch("cosmetic_product_allergies_description_body_zone");
        //this.props.touch('possible_affections');
        //this.props.touch('allergic_reactions_to');
      }
      if (this.state.activeStep == 6) {
        this.props.touch("gender");
        this.props.touch("height");
        this.props.touch("weight");
        this.props.touch("is_smoking");
        this.props.touch("smoking_user_input");
        this.props.touch("has_tattoos");
        // this.props.touch('has_tattoos_value');
        this.props.touch("enrolled_in_other_center");
        this.props.touch("social_security_affiliation");
      }
      if (this.state.activeStep == 7) {
        this.props.touch("health_and_care_products");
        this.props.touch("health_and_care_products_answer");
        this.props.touch("hair_removal_products");
        this.props.touch("hair_removal_zones");
        this.props.touch("hair_removal_products_list");
        this.props.touch("had_laser_hair_removal");
        this.props.touch("had_laser_hair_removal_user_input");
        this.props.touch("policies");
      }

      this.props.dispatch(
        common_alertOpen(
          "Este formulario contiene errores. Por favor, corrígelos!"
        )
      );
    }
    let el = document.getElementById("root");
    el.scrollTop = 0;
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };

  handleToggle = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleCheck = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleCheckBox = name => event => {
    this.setState({
      contact_time: { ...this.state.contact_time, [name]: event.target.checked }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.activeStep !== prevState.activeStep) {
      this.props.changeLayout(this.state.activeStep);
    }

    if (this.props.countryValue !== prevProps.countryValue) {
      this.props.dispatch(geo_fetchRegions(this.props.countryValue));
    }

    if (this.props.regionValue !== prevProps.regionValue) {
      this.props.dispatch(
        geo_fetchCities(this.props.countryValue, this.props.regionValue)
      );
    }
  }
  bmiCalculator(weight, height) {
    if (!height || !weight) {
      return 0;
    }

    height = parseFloat(height.replace(",", "."));
    if (height < 1) {
      this.props.dispatch(common_alertOpen("Invalid height"));
    }
    let result = weight / Math.pow(height, 2);

    return result.toFixed(2);
  }
  renderYesNo(name) {
    return (
      <Grid item xs={12}>
        <Field
          name={name}
          component={renderRadioGroup}
          style={{ display: "block" }}
        >
          {this.props.common.yesno &&
            this.props.common.yesno.map(item => (
              <FormControlLabel
                key={item.id}
                control={<Radio />}
                value={item.value}
                label={item.value}
                style={{
                  width: "45%",
                  float: "left"
                }}
              />
            ))}
        </Field>
      </Grid>
    );
  }
  renderQuestionTitle(title) {
    return (
      <Grid item xs={12}>
        <Typography variant="subheading">{title}</Typography>
      </Grid>
    );
  }

  emailHandleChange = e => {
    this.setState(
      {
        emailInputVal: !!e.target.value
      },
      () => {
        if (this.state.emailInputVal && this.state.passInputVal) {
          this.setState({
            allowNextStep: true
          });
        } else {
          this.setState({
            allowNextStep: false
          });
        }
      }
    );
  };

  passHandleChange = e => {
    this.setState(
      {
        passInputVal: !!e.target.value
      },
      () => {
        if (this.state.emailInputVal && this.state.passInputVal) {
          this.setState({
            allowNextStep: true
          });
        } else {
          this.setState({
            allowNextStep: false
          });
        }
      }
    );
  };

  firstNameHandleChange = e => {
    this.setState(
      {
        firstNameInputVal: !!e.target.value
      },
      () => {
        if (this.state.firstNameInputVal && this.state.lastNameInputVal) {
          this.setState({
            allowNextStep: true
          });
        } else {
          this.setState({
            allowNextStep: false
          });
        }
      }
    );
  };

  lastNameHandleChange = e => {
    this.setState(
      {
        lastNameInputVal: !!e.target.value
      },
      () => {
        if (this.state.firstNameInputVal && this.state.lastNameInputVal) {
          this.setState({
            allowNextStep: true
          });
        } else {
          this.setState({
            allowNextStep: false
          });
        }
      }
    );
  };

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      classes,
      form_other_treatment_value,
      form_had_surgery_value,
      form_skin_affections_value,
      form_has_allergies_value,
      form_family_has_allergies_value,
      form_food_allergies_value,
      form_drug_allergies_value,
      form_cosmetic_product_allergies_value,
      form_weight_value,
      form_height_value,
      form_smoking_value,
      form_tattoos_value,
      form_disease_type_value,
      form_health_and_care_products_value,
      form_hair_removal_products_value,
      form_had_laser_hair_removal_value,
      hair_removal_zones,
      change
    } = this.props;

    const hair_removal_zones_laser_data = [
      { id: 1, value: "Piernas" },
      { id: 2, value: "Línea del bikini" },
      { id: 3, value: "Escroto" },
      { id: 4, value: "Brazos" },
      { id: 5, value: "Axilas" },
      { id: 6, value: "Espalda" },
      { id: 7, value: "Pecho / torso" },
      { id: 8, value: "Bigote" },
      { id: 9, value: "Cejas" },
      { id: 10, value: "Barbilla" }
    ];

    return (
      <form onSubmit={handleSubmit}>
        {this.state.activeStep > 0 && this.state.activeStep <= 7 && (
          <React.Fragment>
            <MobileStepper
              variant="progress"
              steps={7}
              position="static"
              activeStep={this.state.activeStep}
              style={{ width: "100%", marginTop: 20 }}
              classes={{
                progress: classes.progress
              }}
              LinearProgressProps={{
                variant: "determinate",
                value: Math.ceil((this.state.activeStep / 7) * 100),
                style: { width: "100%" }
              }}
            />
            <Typography variant="caption" align="right">
              <span style={{ color: "black" }}>{this.state.activeStep}</span> /
              7
            </Typography>
          </React.Fragment>
        )}
        {this.state.activeStep === 0 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <React.Fragment>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}>
                  <Email style={{ color: primaryGrey }} />
                </Grid>
                <Grid item xs={9}>
                  <div style={{ paddingLeft: 5 }}>
                    <Field
                      name="email"
                      component={renderTextField}
                      ref={input => {
                        this.textInput = input;
                      }}
                      label="Dirección de correo electrónico"
                      onChange={this.emailHandleChange}
                    />
                  </div>
                </Grid>
                <Grid item xs={1}></Grid>
              </React.Fragment>

              <React.Fragment>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}>
                  <LockOutlined style={{ color: primaryGrey }} />
                </Grid>
                <Grid item xs={9}>
                  <div style={{ paddingLeft: 5 }}>
                    <Field
                      name="password"
                      component={renderTextField}
                      label={"Crea tu contraseña"}
                      type="password"
                      ref={input => {
                        this.textPassword = input;
                      }}
                      onChange={this.passHandleChange}
                    />
                    {/*{renderPasswordField()}*/}
                  </div>
                </Grid>
                <Grid item xs={1}></Grid>
              </React.Fragment>

              <React.Fragment>
                <Grid item xs={6} align="center">
                  <Button
                    variant="outlined"
                    color="secondary"
                    disabled={this.state.activeStep === 0}
                    onClick={this.handleBack}
                  >
                    Atrás
                  </Button>
                </Grid>
                <Grid item xs={6} align="center">
                  <Button
                    variant="contained"
                    className={
                      this.state.allowNextStep
                        ? classes.buttonIndigo
                        : classes.buttonIndigoLight
                    }
                    onClick={this.checkEmailandNext}
                  >
                    Siguiente
                  </Button>
                </Grid>
              </React.Fragment>
              <React.Fragment>
                <Grid item xs={12} align="center">
                  <Typography paragraph className="grey-text">
                    Si tienes una cuenta{" "}
                    <Typography
                      component={Link}
                      to="/auth/login"
                      className={classes.logIn}
                      className="green"
                      style={{ display: "initial" }}
                    >
                      Inicia sesión
                    </Typography>
                  </Typography>
                </Grid>
              </React.Fragment>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 1 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="subheading" style={{ fontWeight: 500 }}>
                  Datos personales
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="first_name"
                  component={renderTextField}
                  label={"Nombre real * (Como aparece en el DNI)"}
                  onChange={this.firstNameHandleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="last_name"
                  component={renderTextField}
                  label={"Primer apellido *"}
                  onChange={this.lastNameHandleChange}
                />
              </Grid>
              <Grid item xs={12}>
                {renderSecondLastNameField()}
              </Grid>

              <Grid item xs={1}>
                <CalendarTodayOutlined style={{ color: primaryGrey }} />
              </Grid>
              <Grid item xs={11}>
                <div style={{ paddingLeft: 5 }}>{renderDateOfBirthField()}</div>
              </Grid>

              <Grid item xs={1}>
                <LocationOnOutlined style={{ color: primaryGrey }} />
              </Grid>
              <Grid item xs={11}>
                <div style={{ paddingLeft: 5 }}>
                  {this.props.common.countries &&
                    renderCountriesField(this.props.common.countries)}
                </div>
              </Grid>

              <Grid item xs={1}>
                <LocationOnOutlined style={{ color: primaryGrey }} />
              </Grid>
              <Grid item xs={11}>
                <div style={{ paddingLeft: 5 }}>
                  {renderRegionsField(this.props.geo.regions)}
                </div>
              </Grid>

              <Grid item xs={1}>
                <LocationOnOutlined style={{ color: primaryGrey }} />
              </Grid>
              <Grid item xs={11}>
                <div style={{ paddingLeft: 5 }}>
                  {renderCitiesField(this.props.geo.cities)}
                </div>
              </Grid>

              <Grid item xs={12}>
                {renderNationalitiesField(this.props.common.nationalities)}
              </Grid>

              <Grid item xs={12}>
                {renderDniField()}
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  style={{
                    float: "right",
                    marginRight: -14,
                    fontWeight: 700
                  }}
                  fullWidth
                  control={
                    <Switch
                      checked={this.state.has_children}
                      onChange={event => {
                        change("has_children", !this.state.has_children);
                        this.handleToggle("has_children")(event);
                      }}
                      value="1"
                      classes={{
                        switchBase: classes.colorSwitchBase,
                        checked: classes.colorChecked,
                        bar: classes.colorBar
                      }}
                    />
                  }
                  labelPlacement="start"
                  label="¿Tienes hijos menores de edad?"
                />
              </Grid>
              {this.state.has_children && (
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.accept_children_to_test}
                        onChange={event => {
                          change(
                            "accept_children_to_test",
                            !this.state.accept_children_to_test
                          );
                          this.handleToggle("accept_children_to_test")(event);
                        }}
                        value="1"
                      />
                    }
                    label="Te interesa que tus hijos menores de edad participen en los estudios"
                  />
                </Grid>
              )}

              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
                <Button
                  variant="contained"
                  className={
                    this.state.allowNextStep
                      ? classes.buttonIndigo
                      : classes.buttonIndigoLight
                  }
                  onClick={this.handleNext}
                >
                  Siguiente
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 2 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="subheading" style={{ fontWeight: 500 }}>
                  Datos de contacto
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderAddressField()}
              </Grid>
              <Grid item xs={12}>
                {renderCityField()}
              </Grid>
              <Grid item xs={12}>
                {renderPostalCodeField()}
              </Grid>
              <Grid item xs={12}>
                {renderMobilePhoneField()}
              </Grid>
              <Grid item xs={12}>
                {renderAlternativePhoneNumberField()}
              </Grid>
              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
                <Button
                  variant="contained"
                  className={this.props.classes.buttonIndigo}
                  onClick={this.handleNext}
                >
                  Siguiente
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}

        {this.state.activeStep === 3 && (
          <React.Fragment>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="subheading" style={{ fontWeight: 500 }}>
                  Preferencias de estudios
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" style={{ marginTop: 15 }}>
                  Elija los tipos de test que prefiera realizar
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderTestTypeField(this.props.common.preferred_test_types)}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" style={{ marginTop: 15 }}>
                  Elija la zona del cuerpo donde prefiera realizar estudios
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderTestApplicationZone(
                  this.props.common.preferred_application_zones
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography
                  variant="subheading"
                  style={{ fontWeight: 500, marginTop: 25, marginBottom: 0 }}
                >
                  Preferencias de Contacto
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" style={{ marginTop: 15 }}>
                  Vía de contacto para la invitación a los estudios:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderContactMethodsField()}
              </Grid>

              <Grid item xs={12}>
                <Typography
                  variant="subheading"
                  style={{ fontWeight: 500, marginTop: 25, marginBottom: 0 }}
                >
                  Disponibilidad horaria
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subheading" style={{ marginTop: 15 }}>
                  Disponibilidad horaria de asistencia a los estudios (marcar
                  todas las que pueda):
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {renderContactTimeFiled()}
                {renderGenericHiddenField("account_type", "1")}
              </Grid>

              <Grid item xs={6} align="center">
                <Button
                  variant="outlined"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Atrás
                </Button>
              </Grid>
              <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
                <Button
                  variant="contained"
                  className={this.props.classes.buttonIndigo}
                  onClick={this.handleNext}
                >
                  Siguiente
                </Button>
              </Grid>
              {/* <Grid item xs={6} align="center" style={{ paddingTop: 45 }}>
                <Button
                  variant="contained"
                  type="submit"
                  className={this.props.classes.buttonIndigo}
                  disabled={pristine || submitting}
                >
                  REGÍSTRATE
              </Button>
              </Grid> */}
            </Grid>
          </React.Fragment>
        )}
        {this.state.activeStep === 4 && (
          <Grid container spacing={8} alignItems="flex-end">
            {/* Disease types  */}
            <Grid item xs={12}>
              <Typography variant="subheading" paragraph>
                ENFERMEDADES
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Presenta o ha presentado alguna vez algún tipo de enfermedad de
                las que se exponen a continuación?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="disease_type"
                component={CheckboxGroup}
                options={this.props.common.disease_type || []}
              />
              {form_disease_type_value &&
                form_disease_type_value.map(
                  value =>
                    value === 17 &&
                    renderGenericTextField(
                      "Otras (especificar)",
                      "disease_type_other"
                    )
                )}
            </Grid>

            {/* Medical treatments */}
            <Grid item xs={12}>
              <Typography
                variant="subheading"
                paragraph
                className={classes.mt20}
              >
                TRATAMIENTOS O MEDICAMENTOS
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Está realizando o ha realizado alguna vez algún tratamiento
                inmunosupresor?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="immunosuppressive_treatment"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Está realizando o ha realizado algún otro tratamiento médico en
                los últimos 6 meses?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="other_treatment"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
            </Grid>
            {form_other_treatment_value === "Sí" && (
              <React.Fragment>
                <Grid item xs={12}>
                  <Typography variant="subheading">
                    ¿De qué tipo? Especifique la duración aproximada del
                    tratamiento:
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="other_treatment_description"
                    component={renderTextField}
                    label="Especificar"
                  />
                </Grid>
              </React.Fragment>
            )}

            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Toma de forma recurrente algún medicamento de la siguiente
                lista?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="legal_drug"
                component={CheckboxGroup}
                options={this.props.common.legal_drug || []}
              />

              {/* <Field name="legal_drug" component={renderRadioGroup}>
      {this.props.common.legal_drug && this.props.common.legal_drug.map((item) =>
        <FormControlLabel key={item.id} control={<Radio />} value={item.value} label={item.label} />
      )}
    </Field> */}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Le han realizado alguna vez un trasplante de órgano o una
                ablación de órgano?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="organ_transplant"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Le han realizado alguna intervención quirúrgica recientemente o
                en el último año?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="had_surgery"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
            </Grid>
            {form_had_surgery_value === "Sí" && (
              <React.Fragment>
                <Grid item xs={12}>
                  <Typography variant="subheading">
                    ¿De qué tipo y cuándo?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="had_surgery_description"
                    component={renderTextField}
                    label="Especificar"
                  />
                </Grid>
              </React.Fragment>
            )}

            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Ha tenido alguna vez un traumatismo craneal con pérdida de
                conocimiento prolongada?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="cranial_trauma"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subheading">
                Para las voluntarias de sexo femenino, ¿Utiliza medios de
                contracepción eficaz?
              </Typography>
              <Typography variant="caption">
                (Los hombres no responden)
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="contraception"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
            </Grid>

            {/* Skin affections */}
            <Grid item xs={12}>
              <Typography
                variant="subheading"
                paragraph
                className={classes.mt20}
              >
                AFECCIONES CUTÁNEAS
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subheading">
                ¿Presenta algún tipo de las afecciones cutáneas descritas a
                continuación? (Marque tantas como sea necesario)
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Field
                name="skin_affection"
                component={CheckboxGroup}
                options={this.props.common.skin_affections || []}
                enableAnswer
              />
            </Grid>

            <Grid item xs={6} align="center">
              <Button
                variant="outlined"
                disabled={this.state.activeStep === 0}
                onClick={this.handleBack}
              >
                Atrás
              </Button>
            </Grid>
            <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
              <Button
                variant="contained"
                className={this.props.classes.buttonIndigo}
                onClick={this.handleNext}
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        )}
        {this.state.activeStep === 5 && (
          <Grid container spacing={8} alignItems="flex-end">
            {/* Alergies  */}
            <Grid item xs={12}>
              <Typography variant="subheading" paragraph>
                ALERGIAS
              </Typography>
            </Grid>

            {this.renderQuestionTitle("¿Presenta alguna alergia documentada?")}
            <Grid item xs={12}>
              <Field
                name="has_allergies"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {form_has_allergies_value === "Sí" && (
                <Field
                  name="has_allergies_user_input"
                  component={renderTextField}
                  label="¿A qué? "
                />
              )}
            </Grid>

            {this.renderQuestionTitle(
              "¿En su familia hay personas que padezcan enfermedades alérgicas?"
            )}
            <Grid item xs={12}>
              <Field
                name="family_has_allergies"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {form_family_has_allergies_value === "Sí" && (
                <Field
                  name="family_has_allergies_user_input"
                  component={renderTextField}
                  label="¿Quién?  "
                />
              )}
            </Grid>

            {this.renderQuestionTitle(
              "¿Ha tenido alguna vez reacciones importantes a picaduras de insectos?"
            )}
            {this.renderYesNo("reactions_to_insect_bites")}

            {this.renderQuestionTitle(
              "¿Ha tenido alguna vez reacciones importantes y/o alérgicas al sol (picazón, urticaria, granitos...)?"
            )}
            {this.renderYesNo("reactions_to_sun")}

            {this.renderQuestionTitle(
              "¿Ha tenido alguna vez reacciones alérgicas a algún alimento?"
            )}
            <Grid item xs={12}>
              <Field
                name="food_allergies"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {form_food_allergies_value === "Sí" && (
                <Field
                  name="food_allergies_user_input"
                  component={renderTextField}
                  label="¿A qué alimento(s)?"
                />
              )}
            </Grid>

            {this.renderQuestionTitle(
              "¿Ha tenido alguna vez reacciones alérgicas a algún medicamento?"
            )}
            <Grid item xs={12}>
              <Field
                name="drug_allergies"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {form_drug_allergies_value === "Sí" && (
                <Field
                  name="drug_allergies_user_input"
                  component={renderTextField}
                  label="¿A qué medicamento(s)?"
                />
              )}
            </Grid>

            {this.renderQuestionTitle(
              "¿Ha tenido alguna vez reacciones alérgicas a algún producto cosmético?"
            )}
            <Grid item xs={12}>
              <Field
                name="cosmetic_product_allergies"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {form_cosmetic_product_allergies_value === "Sí" && (
                <React.Fragment>
                  <Field
                    name="cosmetic_product_allergies_description_product"
                    component={renderTextField}
                    label="¿A qué producto(s) cosmético(s)?"
                  />
                  <Field
                    name="cosmetic_product_allergies_description_body_zone"
                    component={renderTextField}
                    label="¿En qué zona del cuerpo tuvo la reacción?"
                  />
                </React.Fragment>
              )}
            </Grid>

            {this.renderQuestionTitle(
              "¿Es usted una persona sujeta a tener...?"
            )}
            <Grid item xs={12}>
              <Field
                name="possible_affections"
                component={CheckboxGroup}
                options={this.props.common.possible_affections || []}
                enableAnswer
                enabledAnswerlabel="¿En qué circunstancias?"
                allowedIndexes={[4, 5]}
              />
            </Grid>
            {this.renderQuestionTitle(
              "¿Ha presentado alguna vez reacciones alérgicas o reacciones adversas a alguno de los siguientes productos?"
            )}
            <Grid item xs={12}>
              <Field
                name="allergic_reactions_to"
                component={CheckboxGroup}
                options={this.props.common.allergies_product_list || []}
              />

              {/* <Field name="allergic_reactions_to" component={renderRadioGroup}>
              {this.props.common.allergies_product_list && this.props.common.allergies_product_list.map((item) =>
                <FormControlLabel key={item.id} control={<Radio />} value={item.value} label={item.label} />
              )}
            </Field> */}
            </Grid>
            <Grid item xs={6} align="center">
              <Button
                variant="outlined"
                disabled={this.state.activeStep === 0}
                onClick={this.handleBack}
              >
                Atrás
              </Button>
            </Grid>
            <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
              <Button
                variant="contained"
                className={this.props.classes.buttonIndigo}
                onClick={this.handleNext}
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        )}
        {this.state.activeStep === 6 && (
          <Grid container spacing={8} alignItems="flex-end">
            {this.renderQuestionTitle("Sexo")}
            <Grid item xs={12}>
              <Field
                name="gender"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                <FormControlLabel
                  control={<Radio />}
                  value="1"
                  label="Femenino"
                  style={{ width: "45%", float: "left" }}
                />
                <FormControlLabel
                  control={<Radio />}
                  value="0"
                  label="Masculino"
                  style={{ width: "45%", float: "left" }}
                />
              </Field>
            </Grid>

            <Grid item xs={12}>
              {renderHeightField()}
            </Grid>

            <Grid item xs={12}>
              {renderWeightField()}
            </Grid>

            {/*<Grid item xs={12}>*/}
            {/*  <Typography*/}
            {/*    variant="subheading"*/}
            {/*    paragraph*/}
            {/*    className={classes.mt20}*/}
            {/*  >*/}
            {/*    BMI: {this.bmiCalculator(form_weight_value, form_height_value)}*/}
            {/*  </Typography>*/}
            {/*</Grid>*/}

            {this.renderQuestionTitle("¿Es fumador/a?")}
            <Grid item xs={12}>
              <Field
                name="is_smoking"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {form_smoking_value === "Sí" && (
                <Field
                  name="smoking_user_input"
                  component={renderTextField}
                  label="¿Cuántos cigarros fuma al día?"
                />
              )}
            </Grid>

            {this.renderQuestionTitle("¿Tiene tatuajes?")}
            <Grid item xs={12}>
              <Field
                name="has_tattoos"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {console.log(form_tattoos_value)}
              {form_tattoos_value === "Sí" && (
                <Field
                  name="has_tattoos_value"
                  component={renderTextField}
                  label="Especifique en qué zona(s)"
                />
              )}
            </Grid>

            {this.renderQuestionTitle(
              "¿Está apuntado/a en otro centro donde realicen pruebas con productos cosméticos?"
            )}
            {this.renderYesNo("enrolled_in_other_center")}

            {this.renderQuestionTitle(
              "¿Está afiliado al régimen de seguridad social o seguro de salud?"
            )}
            {this.renderYesNo("social_security_affiliation")}
            <Grid item xs={6} align="center">
              <Button
                variant="outlined"
                disabled={this.state.activeStep === 0}
                onClick={this.handleBack}
              >
                Atrás
              </Button>
            </Grid>
            <Grid item xs={6} align="center" style={{ paddingTop: 25 }}>
              <Button
                variant="contained"
                className={this.props.classes.buttonIndigo}
                onClick={this.handleNext}
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        )}

        {this.state.activeStep === 7 && (
          <Grid container spacing={8} alignItems="flex-end">
            {this.renderQuestionTitle(
              "¿Utiliza alguno de los siguientes productos?"
            )}
            <Grid item xs={12}>
              <Field
                name="health_and_care_products"
                component={CheckboxGroup}
                options={this.props.common.health_and_care_products || []}
                enableRadioGroupAnswer
                enabledRadioGroupLabels={[
                  { id: 1, value: "Ocasionalmente", label: "Ocasionalmente" },
                  { id: 2, value: "Habitualmente", label: "Habitualmente" }
                ]}
              />
              {form_health_and_care_products_value &&
                form_health_and_care_products_value.indexOf(46) > -1 && (
                  <Field
                    name="consumer_usual_products_other"
                    component={renderTextField}
                    label="Especifique cuál"
                  />
                )}
            </Grid>

            {this.renderQuestionTitle("¿Utiliza productos para depilarse?")}
            {this.renderYesNo("use_hair_removal_products")}

            {form_hair_removal_products_value === "Sí" &&
              this.renderQuestionTitle("¿Dónde? (zona)")}
            {form_hair_removal_products_value === "Sí" && (
              <Grid item xs={12}>
                <Field
                  name="hair_removal_zones"
                  component={CheckboxGroup}
                  options={this.props.common.hair_removal_zones || []}
                />
              </Grid>
            )}
            {form_hair_removal_products_value === "Sí" &&
              this.renderQuestionTitle("¿Qué producto?")}
            {form_hair_removal_products_value === "Sí" && (
              <Grid item xs={12}>
                <Field
                  name="hair_removal_products_list"
                  component={CheckboxGroup}
                  options={this.props.common.hair_removal_products_list || []}
                />
              </Grid>
            )}

            {this.renderQuestionTitle(
              "¿Se hace o se ha hecho la depilación láser?"
            )}
            <Grid item xs={12}>
              <Field
                name="had_laser_hair_removal"
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {this.props.common.yesno &&
                  this.props.common.yesno.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.value}
                      style={{
                        width: "45%",
                        float: "left"
                      }}
                    />
                  ))}
              </Field>
              {/*{form_had_laser_hair_removal_value === 'Sí' &&*/}
              {/*  <Field name="had_laser_hair_removal_user_input" component={renderTextField} label='Especifique en qué zona(s)' />*/}
              {/*}*/}
            </Grid>
            <Grid item xs={12}>
              {form_had_laser_hair_removal_value === "Sí" && (
                <Field
                  name="hair_removal_zones_laser"
                  component={CheckboxGroup}
                  className={classes.mt20}
                  options={hair_removal_zones_laser_data.map(d => ({
                    id: d.id,
                    value: (
                      <Typography variant="caption">
                        <span style={{ color: "black", fontSize: "0.8125rem" }}>
                          {d.value}
                        </span>
                      </Typography>
                    )
                  }))}
                />
              )}
            </Grid>

            <Grid item xs={12} style={{ padding: "30px 25px 30px 25px" }}>
              <Field
                name="policies"
                component={CheckboxGroup}
                className={classes.mt20}
                options={[
                  {
                    id: 1,
                    value: (
                      <Typography variant="caption">
                        Acepto las &nbsp;
                        <Typography
                          component={Link}
                          to="/aviso-legal"
                          variant="caption"
                          target="_blank"
                          style={{ display: "inline-block" }}
                        >
                          <strong>condiciones generales</strong>
                        </Typography>
                        &nbsp; y apruebo el uso de datos personales
                      </Typography>
                    )
                  },
                  {
                    id: 2,
                    value: (
                      <Typography variant="caption">
                        Acepto la &nbsp;
                        <Typography
                          component={Link}
                          to="/politica-cookies"
                          variant="caption"
                          target="_blank"
                          style={{ display: "inline-block" }}
                        >
                          <strong>política de cookies</strong>
                        </Typography>
                      </Typography>
                    )
                  },
                  {
                    id: 3,
                    value: (
                      <Typography variant="caption">
                        Sí, he leido y doy el &nbsp;
                        <Typography
                          component={Link}
                          to="/consentimiento-voluntarios"
                          variant="caption"
                          target="_blank"
                          style={{ display: "inline-block" }}
                        >
                          <strong>consentimiento</strong>
                        </Typography>
                        &nbsp;para CosmoCare
                      </Typography>
                    )
                  }
                ]}
              />
            </Grid>

            <Grid item xs={6} align="center">
              <Button
                variant="outlined"
                disabled={this.state.activeStep === 0}
                onClick={this.handleBack}
              >
                Atrás
              </Button>
            </Grid>
            <Grid item xs={6} align="center">
              {this.state.activeStep === 7 && (
                <Button
                  type="submit"
                  variant="contained"
                  className={classes.buttonIndigo}
                  disabled={pristine || submitting}
                  onClick={this.handleNext}
                >
                  Finalizar
                </Button>
              )}
            </Grid>
          </Grid>
        )}

        <Grid container spacing={8} style={{ marginTop: "10%" }}></Grid>
        {/* 
        <Grid container spacing={8} style={{ marginTop: '10%' }}>
          <Grid item xs={12} align="center">
            <PrivacyPolicyLink />
          </Grid>
        </Grid> */}
      </form>
    );
  }
}

RegisterAccountForm = reduxForm({
  form: "registerAccount",
  validate,
  rerenderOnEveryChange: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})(RegisterAccountForm);

export default withStyles(styles, { withTheme: true })(
  connect(
    null,
    { change, untouch }
  )(RegisterAccountForm)
);



// WEBPACK FOOTER //
// ./src/modules/register/forms/RegisterAccountForm.js